import type { Message } from '#entities/message'
import { respondEventBus } from './respond-event-bus'

export function useTriggerRespond() {
  return (message: Message) => respondEventBus.emit(message.chatId, message)
}
